module.exports = __webpack_public_path__ + "img/step-end@3x.b8dabc8b.png";